module.exports = __webpack_public_path__ + "static/img/12.dcc09fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/12.png
// module id = E4No
// module chunks = 1